import { render, staticRenderFns } from "./AccountDashboard.vue?vue&type=template&id=deadf638&scoped=true"
import script from "./AccountDashboard.vue?vue&type=script&lang=js"
export * from "./AccountDashboard.vue?vue&type=script&lang=js"
import style0 from "./AccountDashboard.vue?vue&type=style&index=0&id=deadf638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deadf638",
  null
  
)

export default component.exports